import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8dab4e56"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=8dab4e56&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports